import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { useInterview } from "../../../services/InterviewProgressContext";

export default function MCQInterviewPage({
  setMcqQuestionsCompleted,
  currentStep,
}) {
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showAnswer, setShowAnswer] = useState(false);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const candidateID = searchParams.get("candidate_id");
  const [questions, setQuestions] = useState();
  const [questionId, setQuestionId] = useState();
  const [timeLeft, setTimeLeft] = useState(30); // Timer starts at 30seconds
  /**
   * Context for the step of the interview
   */
  const { goToStep } = useInterview();

  useEffect(() => {
    generateMcq();
  }, []);

  useEffect(() => {
    if (currentStep == "mcqs") {
      if (timeLeft === 0) {
        handleNext(); // Automatically move to next question when time runs out
      }

      const timer = setInterval(() => {
        setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [currentStep, timeLeft]);

  const generateMcq = async () => {
    setShowAnswer(false);
    setSelectedOption(null);
    setTimeLeft(30); // Reset timer for new question
    SetInterviewStatus();

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/get_next_mcq?jd_id=${id}&candidate_id=${candidateID}&current_que_no=${currentQuestion}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        }
      );

      setQuestionId(response.data.question_id);

      const formattedQuestion = {
        question: response.data.question,
        options: [
          response.data.option_1,
          response.data.option_2,
          response.data.option_3,
          response.data.option_4,
        ],
        answer: response.data.correct_answer,
      };

      setQuestions(formattedQuestion);
      setCurrentQuestion((prev) => prev + 1);
    } catch (error) {
      setMcqQuestionsCompleted(true);
      goToStep("oralQuestions");
    }
  };

  const SetInterviewStatus = async () => {
    const payload = {
      interview_status: "Ongoing",
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/set_interview_status?jd_id=${id}&candidate_id=${candidateID}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } finally {
    }
  };

  const handleNext = async () => {
    setShowAnswer(true);

    await uploadCandidateResponse();
    setTimeout(() => {
      generateMcq();
    }, 1000);
  };

  const uploadCandidateResponse = async () => {
    const payload = { candidate_response: selectedOption };

    try {
      await axios.post(
        `${process.env.REACT_APP_API_KEY}/update_candidate_mcq_response?question_id=${questionId}&jd_id=${id}&candidate_id=${candidateID}`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
    } catch (error) {
      console.error("Error uploading candidate response:", error);
    }
  };

  return (
    <div className="px-6 w-full">
      <motion.div>
        <div className="flex flex-col md:flex-row  text-white rounded-lg shadow-lg">
          {questions && currentStep == "mcqs" && (
            <div className="w-full h-[calc(100vh-190px)]  p-10 flex flex-col items-center justify-center px-4 bg-gray-800 rounded-lg shadow-lg">
              {" "}
              <span className="text-red-500 font-bold flex justify-end mb-2 ">
                Time Left : {timeLeft}s
              </span>{" "}
              <div className="w-full p-4 bg-gray-700 rounded-md mb-4 flex justify-between items-center">
                <h2 className="text-lg font-semibold">{questions.question}</h2>
              </div>
              <div className="w-full space-y-3">
                {questions.options.map((option, index) => {
                  let buttonColor = "bg-gray-600";

                  if (showAnswer) {
                    if (option === questions.answer) {
                      buttonColor = "bg-green-500";
                    } else if (option === selectedOption) {
                      buttonColor = "bg-red-500";
                    }
                  } else if (selectedOption === option) {
                    buttonColor = "bg-blue-500";
                  }

                  return (
                    <button
                      key={index}
                      onClick={() => setSelectedOption(option)}
                      className={`w-full p-2 text-left rounded-lg border-2 transition ${buttonColor}`}
                      disabled={showAnswer}
                    >
                      {option}
                    </button>
                  );
                })}
              </div>
              <button
                onClick={handleNext}
                className="mt-4 bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600"
                disabled={!selectedOption}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
}
